import { requestDeviceUpdate, } from '../../redux/devices/items/actions';
export const saveBackpackContent = (new_content, device_id) => (dispatch) => dispatch(requestDeviceUpdate(device_id, { blockly_contents: new_content }));
